<template>
  <div class="tp-tabs">
    <el-tabs v-model="activeId" @tab-click="handleClick">
      <el-tab-pane
        v-for="item in list"
        :key="item.id"
        :label="item.name"
        :name="item.name"></el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeId: '',
      currentId: ''
    }
  },
  name: 'commonTabs',
  props:{
    list: {
      type: Array,
      default: () => []
    },
    activTabsId: {
      type: String,
      default: ''
    }
  },
  watch: {
    activTabsId:{
      handler(val) {
        if (val) {
          this.activeId = String(val)
        } else {
          this.activeId = String(this.list[0].name)
        }
      },
      immediate: true
    },
    activeId: {
      handler() {
        // const index = this.list.find(res => res.id == val)
        // if (index) {
        //   this.$emit('handleClick', index)
        // }
      }
    }
  },
  methods: {
    handleClick() {
      const index = this.list.find(res => res.name == this.activeId)
      if (index) {
        this.$emit('handleClick', index)
      }
      // const index = this.list.find(res => res.id == node.name)
      // if (index) {
      //   this.$emit('handleClick', index)
      // }
    }
  }
}
</script>
<style lang="scss" scoped>
  .tp-tabs{
    height: 37px;
    width: 80%;
    margin-left: -10px;
    margin-bottom: 2px;

    /deep/ {
      .el-tabs__header {
        margin-bottom: 0;
      }

      .el-tabs__item {
        height: 37px;
        line-height: inherit;
        margin: 0 15px;
        padding: 0 10px !important;
        font-family: OpenSans;
        font-weight: 600;
        font-size: 14px;
        color: #4C556C;
        box-shadow: none !important;
        &:hover {
          color: #000;
        }

        &.is-active{
          border-bottom: 3px solid #4066d4;
        }

        &:nth-child(2){
          margin-left: 0;
        }
      }

      .el-tabs__nav-wrap::after{
        display: none;
      }

      .el-tabs__item.is-active{
        color: #4066d4;
      }

      .el-tabs__active-bar{
        display: none;
      }
    }
  }
</style>
